// extracted by mini-css-extract-plugin
export default {"addToWallet":"_2arBR","ticketInfo":"A4rnh"};